import React from 'react'
import { IconMaximize, IconMinus, IconPlus, IconLayoutGrid } from '@tabler/icons-react'

import { Button } from '@/components/buttons/Button'

// Small floating control cluster: zoom in / zoom level chip / zoom out / fit
// to view / reset layout. Sits at the canvas top-right via SCSS positioning.
const CanvasControls = ({ zoom, onZoomIn, onZoomOut, onResetZoom, onFitToView, onResetLayout }) => (
  <div className="voice-agents__canvas-controls" data-testid="canvas-controls">
    <Button
      basic
      square
      small
      onClick={onZoomOut}
      data-testid="canvas-zoom-out"
      aria-label="Zoom out"
    >
      <IconMinus />
    </Button>
    <Button
      basic
      small
      className="voice-agents__canvas-zoom-level"
      onClick={onResetZoom}
      data-testid="canvas-zoom-level"
      title="Click to reset zoom to 100%"
    >
      {Math.round(zoom * 100)}%
    </Button>
    <Button basic square small onClick={onZoomIn} data-testid="canvas-zoom-in" aria-label="Zoom in">
      <IconPlus />
    </Button>
    {onFitToView && (
      <Button
        basic
        square
        small
        onClick={onFitToView}
        data-testid="canvas-fit-to-view"
        aria-label="Fit to view"
        title="Fit graph to view"
      >
        <IconMaximize />
      </Button>
    )}
    <Button
      basic
      square
      small
      onClick={onResetLayout}
      data-testid="canvas-reset-layout"
      aria-label="Reset layout"
      title="Reset node positions"
    >
      <IconLayoutGrid />
    </Button>
  </div>
)

export default CanvasControls
